import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { map, forEach, filter, orderBy } from 'lodash';
import update from 'immutability-helper';
import { PersonalAccountInformation } from '../models/AccountModels';
import { NotificationTypeEnum, NotificationToast } from '../models/NotificationModels'
import { MobileService, } from '../models/ServiceModels'
import { ToastNotificationManager } from '../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { AccountManagerRequests } from '../apiRequests/AccountManagerRequests';
import { ServicesRequests } from '../apiRequests/ServicesRequests';
import { AppealRequests } from '../apiRequests/AppealRequests';
import { AppealTopic, AppealTag, AppealAdditionalTag } from '../models/AppealReferanceModels';


export interface GuideState {
    topics: AppealTopic[]
    tags: AppealTag[]
    addTags: AppealAdditionalTag[]
    guideIsLoad: boolean;
    isError: boolean;
}


export interface InitGuideStateAction {
    type: 'INIT_GUIDE_STATE';
}

export interface UnmountGuideStateAction {
    type: 'UNMOUNT_GUIDE_STATE';
}

export interface GetGuideStateAction {
    type: 'GET_GUIDE_STATE';
    topics: AppealTopic[];
    tags: AppealTag[];
    addTags: AppealAdditionalTag[]
}

export interface SetErrorAction {
    type: 'SET_ERROR';
}

const apiAppealRequest = new AppealRequests();

type KnownAction = InitGuideStateAction | UnmountGuideStateAction | GetGuideStateAction | SetErrorAction;


export const actionCreators = {

    InitGuideAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        apiAppealRequest.Init();

        dispatch({
            type: 'INIT_GUIDE_STATE',
        });

    },
    UnMountGuideAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'UNMOUNT_GUIDE_STATE',
        });

    },

    GetGuideStateAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {


        let topics = await apiAppealRequest.GetAppealTopics();
        let tags = await apiAppealRequest.GetAppealTags();
        let additionalTags = await apiAppealRequest.GetAppealAdditionalTags();


        if (!topics.result && !tags.result && !additionalTags.result) {
            dispatch({ type: 'SET_ERROR', });
            return;
        }

        dispatch({
            type: 'GET_GUIDE_STATE',
            topics: topics.data,
            tags: tags.data,
            addTags: additionalTags.data


        });

    },

};


const unloadedState: GuideState = {
    topics: [], tags: [], addTags: [], guideIsLoad: false, isError: false
};

export const reducer: Reducer<GuideState> = (state: GuideState | undefined, incomingAction: Action): GuideState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {

        case 'INIT_GUIDE_STATE':
        case 'UNMOUNT_GUIDE_STATE':
        default:
            return {
                ...state,

            };

        case 'GET_GUIDE_STATE':
            return {
                ...state,
                tags: action.tags,
                topics: action.topics,
                addTags: action.addTags,
                guideIsLoad: true

            };

        case 'SET_ERROR':
            return {
                ...state,
                isError: true

            };

    };


};
